// The workflows (modules) a project can move through, as a single source of
// truth shared by the sidebar filters, the per-workflow project lists, and the
// in-project tab bar. `key` matches the backend module id + the project payload's
// `workflows` flags; `path` is the project-scoped route segment for that tab.

export interface WorkflowMeta {
  key: "proofing" | "audio_analysis" | "toc";
  label: string;
  icon: string;
  path: string; // appended to /projects/:id (proofing is the root)
  listSub: string; // subtitle on the filtered project list
}

export const WORKFLOWS: WorkflowMeta[] = [
  {
    key: "proofing",
    label: "Proofing",
    icon: "headphones",
    path: "",
    listSub: "Projects you're proofing against the manuscript.",
  },
  {
    key: "audio_analysis",
    label: "Spec check",
    icon: "audio-waveform",
    path: "/specs",
    listSub: "Projects checked against platform delivery specifications.",
  },
  {
    key: "toc",
    label: "Table of Contents",
    icon: "list-tree",
    path: "/toc",
    listSub: "Projects with a Table of Contents to check against the guidelines.",
  },
];

export function workflowByKey(key: string): WorkflowMeta | undefined {
  return WORKFLOWS.find((w) => w.key === key);
}

// The project route for a workflow (proofing → /projects/:id, spec check →
// /projects/:id/specs). Used so opening a project from a workflow list lands on
// that workflow's tab.
export function projectHref(projectId: string, workflowKey?: string): string {
  const w = workflowKey ? workflowByKey(workflowKey) : undefined;
  return `/projects/${projectId}${w?.path ?? ""}`;
}
